import { z } from 'zod';
import { ROLES, SCOPED_ROLES } from '../roles.js';

// Die VERGABE einer Rolle: was der Client in den Body schreibt (`initial_role`, `roles.add`,
// `roles.remove`). Bewusst OHNE project_id — das Projekt kommt aus der URL, der Server schreibt
// die Rolle immer auf das Projekt der Route. Ein zusätzlich akzeptiertes, aber nie gelesenes
// project_id wäre ausgerechnet in der Rechte-API eine Falle für den nächsten Leser.
export const RoleGrantSchema = z.object({
  role: z.enum(ROLES),
  scope_node_id: z.string().uuid().nullable(),
});
export type RoleGrant = z.infer<typeof RoleGrantSchema>;

// Dieselbe Vergabe, aber fuer SCHREIBENDE Pfade (`initial_role`, `roles.add`): ein Struktur-Knoten
// darf nur an einer Rolle haengen, die ueberhaupt scope-faehig ist. Sonst entstuende ein Feld ohne
// Wirkung — genau die „totes Feld"-Falle aus CLAUDE.md: Ein Consultant mit `scope_node_id` sah in
// der Nutzerverwaltung nach Teilprojekt-Zuschnitt aus, war es aber nie (SCOPED_ROLES).
//
// Bewusst NICHT auf `roles.remove` angewandt: eine Altzuweisung, die es nach heutiger Regel nicht
// mehr geben duerfte, muss entfernbar bleiben.
export const RoleGrantWriteSchema = RoleGrantSchema.superRefine((v, ctx) => {
  if (v.scope_node_id !== null && !SCOPED_ROLES.includes(v.role)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['scope_node_id'],
      message: 'scope_not_supported_for_role',
    });
  }
});

// Die BESTEHENDE Rollenzuweisung, wie sie in der Sitzung (`AuthenticatedUser.roles`) steht.
// #23: Die Rolle gilt für GENAU EIN Projekt. Optional, damit ältere Fixtures gültig bleiben;
// die projekt-gescopte Sicht aus project-scope.ts füllt das Feld immer.
export const RoleAssignmentSchema = RoleGrantSchema.extend({
  project_id: z.string().uuid().nullish().default(null),
});
export type RoleAssignment = z.infer<typeof RoleAssignmentSchema>;

export const AuthenticatedUserSchema = z.object({
  user_id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  is_external: z.boolean(),
  roles: z.array(RoleAssignmentSchema),
});
export type AuthenticatedUser = z.infer<typeof AuthenticatedUserSchema>;
